import React, {useState} from 'react';
import PropTypes from 'prop-types';
import ShowMoreText from 'react-show-more-text';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import moment from 'moment';

import ROUTES from 'config/routes';
import {forumStatuses} from 'config/constants';
import formatDate from 'helpers/formatDate';
import Icon, {ICON_NAMES} from 'components/Icon';
import CardMenu from './CardMenu';
import Button from "../Button";


const ForumCard = props => {
  const {item, withMenu, categories, isOwn, freePosts} = props;
  const category = categories.find(cat => cat.id === item.category_id);
  const [openedMenu, setOpenedMenu] = useState(false);

  const toggleMenu = (event) => {
    setOpenedMenu(!openedMenu);
  }

  const status = forumStatuses.find(statusItem => statusItem.value === item.status);
  const isNeedPay = item.status === "awaiting_payment";

  return (
    <div className="card-item card-item--forum forum-item">
      {
        isOwn && status &&
        <div className={classNames(`card-item__label`, {
          'card-item__label-red': item.status === "rejected",
          'card-item__label-blue': item.status === "moderation",
          'card-item__label-yellow': item.status === "awaiting_payment",
          'card-item__label-green': item.status === "published",
        })}>{status.title}</div>
      }
      <div className="row">
        <div className="col-12 col-md-6">
          <div className="card-item__field">
            <Link
              className="card-item__name card-item__link"
              to={`${ROUTES.forumDetails}/${item.id}`}>{item.title}</Link>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="card-item__title-row">
            <div className="card-item__title">
              <div className="card-item__field">
                <div className="card-item__field-title">category</div>
                <div className="card-item__field-text">{category && category.name}</div>
              </div>
            </div>
            {
              withMenu &&
              <div className="card-item__menu">
                <button
                  className="card-item__menu-btn"
                  onClick={toggleMenu}>
                  <Icon
                    name={ICON_NAMES.more}
                    className="card-item__menu-ico" active={true}/>
                </button>
                {
                  openedMenu &&
                  <CardMenu
                    onClose={toggleMenu}
                    id={item.id}
                    isNeedPay={isNeedPay}
                    freePosts={freePosts}/>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <div className="row last-row">
        <div className="col-12 col-md-6">
          <div className="card-item__field">
            <div className="card-item__field-title">author</div>
            <div className="card-item__field-text">{item.author}</div>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="card-item__field">
            <div className="card-item__field-title">description</div>
            <div className="card-item__field-text">
              <ShowMoreText
                lines={4}
                more=''
                less=''
                anchorClass="show-more-button show-more-button--forum"
                expanded={false}>
                <p>{item.description}</p>
              </ShowMoreText>
            </div>
          </div>
        </div>
      </div>
      {
        isOwn &&
        isNeedPay &&
        (!freePosts || freePosts === 0) &&
        <Button
          width="min"
          bgColor="transparent"
          to={`${ROUTES.paymentForum}/${item.id}`}>{item.expired_at ? 'Renew and Pay':  'Pay and post'}</Button>
      }
      {
        isOwn && item.started_at && item.expired_at && (
          moment(item.expired_at).unix() > moment().unix()
            ? <div className="card-item__dates">{`Active: ${formatDate(item.started_at)} - ${formatDate(
            item.expired_at)}`}</div>
            : <div className="card-item__dates date-expired">{`Active: ${formatDate(item.started_at)} - ${formatDate(
            item.expired_at)}`}</div>
        )
      }
    </div>
  );
}

ForumCard.propTypes = {
  withMenu: PropTypes.bool,
};

ForumCard.defaultProps = {
  withMenu: false,
};

export default ForumCard;